<script>
  export default {
    name: 'Snackbar',
    data(){
      return{
        message: "",
        type: "",
      }
    },
    created(){
      this.$store.watch(
        //Quand state.alert change de valeur
        (state) => {
          return state.alert
        },
        //Alors j'execute j'exécute ce callback
        // (newValue, oldValue) => {
        (newValue) => {
          // let message = newValue.message
          // if (newValue.status){
          //   message += ' (' + newValue.status + ').'
          // } else {
          //   message += '.'
          // }
          this.message = newValue.message + '.'

          setTimeout(() => {
            this.message = "";
          }, 2500); //durée fonction de la taille de 'message' ? Ou passer la durée via le store ? Les message de confirmation ne méritent pas de rester affichés trop longtemps...
        },
        //Optional Deep if you need it
        {deep:true}
      )
    },
    methods: {

    },
  };
</script>

<template>
    <transition name="modal-fade" appear="">
      <div class="snackbar" v-if="message != ''">
        {{message}}
      </div>
    </transition>
</template>

<style lang="scss">
@import '../assets/main.scss';

.snackbar{
  @include myFont;
  font-size: 13px;
  background-color: $black-bold;
  color: white;
  width: 350px;
  padding: 15px;
  border-radius: 4px;
}

// --------------------------------
//          Transitions
// --------------------------------
  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.3s ease
  }


</style>